<ng-template #content let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">Get Help</h2>
    <button type="button" class="close" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-8">
        <h3>Vocabulary</h3>
        @if (aCTcontent) {
          <ul ngbNav #t="ngbNav" class="nav-pills justify-content-center">
            <li [ngbNavItem]="0">
              <a ngbNavLink>{{ aCTcontent.subjects[0].title }}</a>
              <ng-template ngbNavContent>
                <div class="help-content">
                  <div ngbAccordion [closeOthers]="true">
                    @for (topic of aCTcontent.subjects[0].topics; track topic; let index = $index) {
                      <div [ngbAccordionItem]="'' + index">
                        <h2 ngbAccordionHeader>
                          <button ngbAccordionButton>{{ topic.title }}</button>
                        </h2>
                        <div ngbAccordionCollapse>
                          <div ngbAccordionBody>
                            <ng-template>
                              Definition. {{ topic.description }}
                              <h6>Example</h6>
                              Example. {{ topic.example }}
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="1">
              <a ngbNavLink>{{ aCTcontent.subjects[1].title }}</a>
              <ng-template ngbNavContent>
                <div class="help-content">
                  <div ngbAccordion [closeOthers]="true">
                    @for (topic of aCTcontent.subjects[1].topics; track topic; let index1 = $index) {
                      <div [ngbAccordionItem]="'' + index1">
                        <h2 ngbAccordionHeader>
                          <button ngbAccordionButton>{{ topic.title }}</button>
                        </h2>
                        <div ngbAccordionCollapse>
                          <div ngbAccordionBody>
                            <ng-template>
                              Definition. {{ topic.description }}
                              <h6>Example</h6>
                              Example. {{ topic.example }}
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink>{{ aCTcontent.subjects[2].title }}</a>
              <ng-template ngbNavContent>
                <div class="help-content">
                  <div ngbAccordion [closeOthers]="true">
                    @for (topic of aCTcontent.subjects[2].topics; track topic; let index2 = $index) {
                      <div [ngbAccordionItem]="'' + index2">
                        <h2 ngbAccordionHeader>
                          <button ngbAccordionButton>{{ topic.title }}</button>
                        </h2>
                        <div ngbAccordionCollapse>
                          <div ngbAccordionBody>
                            <ng-template>
                              Definition. {{ topic.description }}
                              <h6>Example</h6>
                              Example. {{ topic.example }}
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink>{{ aCTcontent.subjects[3].title }}</a>
              <ng-template ngbNavContent>
                <div class="help-content">
                  <div ngbAccordion [closeOthers]="true">
                    @for (topic of aCTcontent.subjects[3].topics; track topic; let index2 = $index) {
                      <div [ngbAccordionItem]="'' + index2">
                        <h2 ngbAccordionHeader>
                          <button ngbAccordionButton>{{ topic.title }}</button>
                        </h2>
                        <div ngbAccordionCollapse>
                          <div ngbAccordionBody>
                            <ng-template>
                              Definition. {{ topic.description }}
                              <h6>Example</h6>
                              Example. {{ topic.example }}
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
        }
        <div [ngbNavOutlet]="t"></div>
      </div>
      <div class="col-4">
        <h3>Ask A Tutor</h3>
        <form [formGroup]="askTutorForm" (ngSubmit)="sendEmail()">
          <div class="form-group">
            <label class="sr-only" for="helpMessage">Tell us your question</label>
            <textarea class="form-control" [formControl]="askTutorForm.controls['helpMessage']" id="helpMessage"
            placeholder="Tell us your question" rows="8"></textarea>
          </div>
          <button type="submit" [disabled]="!askTutorForm.valid" class="btn btn-primary btn-block">Submit Question
          </button>

          <p>Help Reply Expectations. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus faucibus
            scelerisque libero vitae sollicitudin. Proin eleifend, tortor id commodo tincidunt, augue ligula porttitor
          enim, eget porta odio eros in neque.</p>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<button class="btn-help btn btn-outline-primary" (click)="open(content)">
  <i class="fa fa-question"></i>
</button>
